export const plans = {
  title: "اختر خطتك",
  subtitle: "السعر لكل وحدة شهريًا، مع خصومات حسب الحجم. يمكنك الجمع بين عدة أنواع من أماكن الإقامة في طلب واحد.",
  typeLabel: "نوع الإقامة",
  types: {
    apartamento: "شقق",
    hotel: "فندق",
    camping: "مخيّم",
    villa: "فلل",
  },
  units: {
    apartamento: "شقة | شقق",
    hotel: "غرفة | غرف",
    camping: "وحدة | وحدات",
    villa: "فيلا | فلل",
  },
  decrease: "إزالة وحدة",
  increase: "إضافة وحدة",
  billing: {
    label: "الفوترة",
    monthly: "شهري",
    annual: "سنوي",
    annualSave: "−20%",
  },
  perUnit: "/شهريًا لكل وحدة",
  totalLine: "{qty} {units} · {total}/شهريًا إجمالًا",
  billedAnnually: "يُفوتر سنويًا",
  add: "أضف إلى الطلب",
  isNew: "جديد",
  pro: {
    badge: "الأكثر شيوعاً",
    tagline: "المنصّة كاملة: ذكاء اصطناعي وقنوات ومدفوعات ودخل.",
    f1: "تسجيل وصول عبر الإنترنت وإرسال بيانات النزلاء إلى السلطات تلقائيًا",
    f2: "استقبال بالذكاء الاصطناعي 24/7 عبر واتساب: يخدم النزلاء ويجيب عن الأسئلة ويؤتمت المهام",
    f3: "صندوق وارد موحّد (واتساب + Booking وAirbnb وExpedia)، ترجمة وتحويل إلى موظف بشري",
    f4: "فوترة إلكترونية VeriFactu",
    f5: "Channel Manager بأكثر من 100 وكالة OTA، تقويم موحّد وإدارة للأسعار (صفر حجز زائد)",
    f6: "حجوزات مباشرة عبر موقعك الخاص، دون عمولات",
    f7: "أقفال ذكية برموز دخول تلقائية",
    f8: "خدمات إضافية وترقيات وتمديد الإقامة وعروض",
    f9: "تحصيل ومدفوعات مع دفعات مقدّمة",
    f10: "تنظيف وفريق العمل، بأدوار وصلاحيات",
    f11: "تعدّد العقارات وتحليلات وتقارير لكل مالك",
  },
  suite: {
    badge: "شامل كل شيء",
    tagline: "الخطة الأكثر اكتمالاً: استقبال هاتفي بالذكاء الاصطناعي وموقعك الخاص وأسعار ديناميكية.",
    lead: "كل ما في Pro، بالإضافة إلى:",
    s1: "رقم خاص بك لواتساب والمكالمات",
    s2: "استقبال هاتفي بالذكاء الاصطناعي: يرد على الهاتف 24/7 بلغة النزيل",
    s3: "مكالمات واردة: 40 دقيقة/شهرياً مشمولة",
    s4: "WebBuilder: موقعك الإلكتروني الكامل",
    s5: "أسعار ديناميكية: تعديل تلقائي للتعرفة",
    s6: "كيانات فوترة متعددة لربطها بكل إقامة",
  },
  cart: {
    title: "طلبك",
    empty: "اختر نوع الإقامة وعدد الوحدات، ثم أضف خطة.",
    plan: "خطة {plan}",
    remove: "إزالة",
    monthlyTotal: "الإجمالي شهريًا",
    annualTotal: "يُفوتر سنويًا: {total}",
    planSwitched: "للطلب خطة واحدة فقط: أصبح كل شيء {plan}.",
    welcomeTitle: "تم تطبيق خصم الدعوة",
    welcomeMonthly: "خصم {percent}% خلال أول {months} أشهر: {total}/شهريًا",
    welcomeAnnual: "توفّر {amount} في أول فاتورة سنوية",
    pay: "المتابعة إلى الدفع",
    paying: "جارٍ فتح صفحة الدفع…",
    taxes: "الضرائب غير مشمولة. سيطلب منك Stripe بيانات الفوترة.",
    error: "تعذّر فتح صفحة الدفع. حاول مجددًا.",
  },
  payment: {
    success: "تم استلام الدفع. ستُفعَّل خطتك خلال ثوانٍ.",
    failed: "لم يكتمل الدفع. يمكنك المحاولة مجددًا متى شئت.",
    active: "تم! خطتك مفعّلة الآن.",
  },
  active: {
    includes: "ما تتضمنه خطتك",
    discount: "خصم الدعوة: {percent}% حتى {date}",
    discountAnnual: "تم تطبيق خصم الدعوة على فاتورتك الأولى",
    referralCredit: "لديك رصيد {amount} لدعوتك مضيفين آخرين: سيُخصم من فاتورتك القادمة.",
  },
};
